var React = require('react');

function Bold (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.00006 11.25H14.2501C15.2446 11.25 16.1985 11.6451 16.9017 12.3483C17.605 13.0516 18.0001 14.0054 18.0001 15C18.0001 15.9945 17.605 16.9484 16.9017 17.6516C16.1985 18.3549 15.2446 18.75 14.2501 18.75L5.99951 18.7495V4.49951L13.1251 4.49997C14.0202 4.49997 14.8786 4.85555 15.5115 5.48848C16.1445 6.12142 16.5001 6.97986 16.5001 7.87497C16.5001 8.77007 16.1445 9.62852 15.5115 10.2615C14.8786 10.8944 14.0202 11.25 13.1251 11.25","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Bold.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = Bold;

Bold.default = Bold;
